import { render, staticRenderFns } from "./rightPartOther.vue?vue&type=template&id=07ef6189&scoped=true&"
import script from "./rightPartOther.vue?vue&type=script&lang=js&"
export * from "./rightPartOther.vue?vue&type=script&lang=js&"
import style0 from "./rightPartOther.vue?vue&type=style&index=0&id=07ef6189&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ef6189",
  null
  
)

export default component.exports